import Delete from '@mui/icons-material/Delete';
import { Box, Button, Dialog, DialogContent, IconButton, Tooltip, Typography } from '@mui/material';
import FilePreviewCard from '../../../Utils/FileUpload/FilePreviewCard';
import StatusChip from '../../../MUI_custom_component/chips/StatusChip';
import { useState } from 'react';
import { Base64Image } from '../../../../utils/settings';

const BankDetailCard = ({ details, handleDelete = null, isNominee=false, beneficiary_id=null , handleEdit=null }) => {
    const [openImage, setOpenImage] = useState(false);
    const DetailField = ({ label, value }) => (
        <Box sx={{ py: 1}}>
            <Typography fontWeight={700} sx={{ color: "#666666", fontSize: '13px', lineHeight: '20px', }}>{label}</Typography>
            <Typography sx={{ color: "#333333", fontSize: '16px', pr: 1, lineHeight: '24px', fontWeight: 400 }}>{value}</Typography>
        </Box>
    );
    const DetailFieldWithImage = ({ openImage, handleClose}) => (
        <Dialog open={openImage} onClose={handleClose} maxWidth="sm">
            <DialogContent sx={{ textAlign: "center" }}>
                <Base64Image
                    base64String={details?.uploaded_image.id_str_base64}
                    style={{ width: '400px', marginBottom: '10px' }}
                />
            </DialogContent>
        </Dialog>
    );
    const handleViewImage = (id) => {
        setOpenImage(true);
    };
    const handleClose = () => {
        setOpenImage(false);
    };
    return (
        <Box>
            {details?.verification_status?.status_message && (
                <Typography variant="body1" sx={{ color: '#CC0000', mb: 3 }}>
                    {details?.verification_status?.status_message}
                </Typography>
            )}
            {details?.verification_status && (
                <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' }}>
                    <Typography variant="body2" sx={{ fontSize: '20px', lineHeight: '32px', fontWeight: 600, color:'#000' }}>
                        {details?.verification_status?.label}
                    </Typography>
                    <StatusChip type='outlined' status={details?.verification_status?.value} label={details?.verification_status?.value} />
                </Box>
            )}
            {details?.is_editable && (
                <Button 
                    variant="contained" 
                    size="small" sx={{ mb: 3, textTransform: 'none', px: 3, position: 'relative', width: { md: 'fit-content', xs:'100%' }, display: { xs: 'block',md: 'none' } }}
                    onClick={() => handleEdit(details)} 
                >
                    Edit
                </Button>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb:1 }}>
                <Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '20px', lineHeight: '32px' }}>
                        {details?.header_title}
                    </Typography> 
                </Box>
                <Box>
                    {details?.is_editable && (
                        <Button variant="contained" sx={{textTransform: 'none', px: 3, display: { xs:'none',md: 'block' }}} size="small" onClick={() => handleEdit(details)} >
                            Edit
                        </Button>
                    )}
                    
                    {handleDelete && details?.isDeletable && (
                        <Tooltip title="Delete">
                            <IconButton size="small" sx={{ color: '#FFA525' }}
                                onClick={() => {
                                    if (isNominee && beneficiary_id && details.id) {
                                        handleDelete(beneficiary_id, true, details?.id);
                                    } else if (details.id) {
                                        handleDelete(details.id);
                                    }
                                }}
                            >
                                <Delete fontSize='small' />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            </Box>
            <Box sx={{ mb: 2 }}>
                {details?.details.map((field, idx) => (
                    <DetailField
                        key={idx}
                        label={field.display_name}
                        value={field.display_value}
                        file_url={field.file_url}
                    />
                ))}
            </Box>
            {details?.uploaded_image && (
                <>
                    <Box onClick={() => handleViewImage(details?.uploaded_image?.id_str_base64)} sx={{ cursor: 'pointer', mb: 2 }}>
                        <Typography variant="body2" sx={{ color: '#000', fontSize: '16px', fontWeight: 700, lineHeight: '24px', mb: 1 }}>{details?.uploaded_image?.label}</Typography>
                        <FilePreviewCard filePreview={details?.uploaded_image?.id_str_base64} uploadedFile={details?.uploaded_image} isExisting={true} />
                    </Box>
                    <DetailFieldWithImage openImage={openImage} handleClose={handleClose} />
                </>
            )}
            
        </Box>
    )
}

export default BankDetailCard